/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserProvider } from 'src/app/providers/index';
import { User } from 'src/app/model';
import { FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LogService } from 'src/app/services';

@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.page.html',
  styleUrls: ['change-password.page.scss']
})
export class ChangePasswordPage {

  @Output() onCreate: EventEmitter<boolean> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Input() user: User = new User();

  changeForm: FormGroup;
  constructor(
    public userProvider: UserProvider,
    private fb: FormBuilder,
    private logService :LogService
  ) {
    this.changeForm = this.fb.group({
      USER_PASSWORD: [null, Validators.compose([Validators.required, Validators.pattern('^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])[\\w~@#$%^&*+=`<>|{}:=’;!.?\\"()\\[\\]\\/-]{12,}$')])],
      USER_CONFIRM_PASSWORD: [null, Validators.compose([Validators.required, this.compareValidator('USER_PASSWORD')])]
    });
  }

  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }

      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }

      return controlToCompare && controlToCompare.value !== c.value ? { 'compare': true } : null;
    };
  }

  onSubmit(): void {
    if (this.changeForm.valid) {
      this.userProvider.changePassword(this.changeForm.value.USER_PASSWORD)
        .subscribe(data => {
          if (data.success) {
            this.onCreate.emit(true);
          } else {
            this.logService.error(JSON.stringify(data, null, 2));
          }
        });
    }
  }

  actionCancel(): void {
    this.onCancel.emit();
  }
}
